/* eslint-disable no-plusplus,no-restricted-syntax */

import _ from 'lodash';
import Immutable from 'immutable';
import { createSelector } from 'reselect';
import { USER_RESOURCE, COMMENT, PAGE, COLLECTED_ITEM } from '../resourceNames';
import {
  selectReadSubscriptionsById,
  selectUnreadSubscriptionsById,
  selectSubscriptionsById,
} from '../Subscriptions/selectors';
import { selectChannelsById } from '../Channels/selectors';
import { selectEventsByChannel } from '../NotificationEvents/selectors';
import { selectUsersById, currentUserSelector } from '../Users/selectors';
import { currentUserIdSelector } from '../Auth/selectors';
import { coursesSelector } from '../Courses/selectors';
import { pagesByIdSelector } from '../Pages/selectors';
import { selectPostsById } from '../Posts/selectors';
import { certificatesById } from '../Certification/Certificates/selectors';
import { badgesById } from '../IssuedBadges/selectors';
import { selectCommentsSummaryById } from '../Comments/CommentsSummary/selectors';
import { cohortsSelector } from '../Cohorts/selectors';
import { selectInstitutions } from '../Institutions/selectors';
import {
  ACTION_LIKE_POST,
  ACTION_LIKE,
  ACTION_REPLY,
  ACTION_ADDED_CONTENT,
  ACTION_NEW_SINGLE_POST,
  ACTION_NEW_POST,
  ACTION_NEW_COMMENT,
  ACTION_BADGE_ISSUED,
  ACTION_RELEASED,
  ACTION_CERTIFICATE_ISSUED,
  ACTION_CERTIFICATE_REFRESHED,
  ACTION_TAG,
} from '../../native/config/notificationActions';

// created types
const LIKE = 'like';
const ANNOUNCEMENT = 'announcement';
const CERTIFICATE = 'certificate';
const BADGE = 'badge';

export const notificationsSelector = (state) => state.Notifications;

export const selectReadFetchingStatus = createSelector(
  notificationsSelector,
  (notifications) => {
    return notifications.getIn(['read', 'fetching']);
  }
);

export const selectUnreadFetchingStatus = createSelector(
  notificationsSelector,
  (notifications) => {
    return notifications.getIn(['unread', 'fetching']);
  }
);

export const selectReadRefreshingStatus = createSelector(
  notificationsSelector,
  (notifications) => {
    return notifications.getIn(['read', 'refreshing']);
  }
);

export const selectUnreadRefreshingStatus = createSelector(
  notificationsSelector,
  (notifications) => {
    return notifications.getIn(['unread', 'refreshing']);
  }
);

export const selectReadLoadingStatus = createSelector(
  notificationsSelector,
  (notifications) => {
    return notifications.getIn(['read', 'loading']);
  }
);

export const selectUnreadLoadingStatus = createSelector(
  notificationsSelector,
  (notifications) => {
    return notifications.getIn(['unread', 'loading']);
  }
);

export const selectReadCursor = createSelector(
  notificationsSelector,
  (notifications) => {
    return notifications.getIn(['read', 'cursor']);
  }
);

export const selectUnreadCursor = createSelector(
  notificationsSelector,
  (notifications) => {
    return notifications.getIn(['unread', 'cursor']);
  }
);

const constructActors = (actors) => {
  const uniqueActors = actors.toSet().toList();
  const actorNames = uniqueActors.reduce((current, actor, index) => {
    return current.set(index, actor.get('fullName'));
  }, Immutable.List());
  let result = '';
  if (actorNames.size === 1) {
    result = actorNames.get(0);
  } else if (actorNames.size === 2) {
    result = actorNames.join(' and ');
  } else if (actorNames.size > 2) {
    for (let i = 0; i < 2; i++) {
      result = result.concat(`${actorNames.get(i)}, `);
    }
    result = result.concat('and others');
  }
  return result;
};

const constructActionType = (
  actors,
  actionType,
  createdByMe,
  currentUser,
  creator
) => {
  let finalActionType = '';
  const uniqueActors = actors.toSet().toList();
  const numOfActors = uniqueActors.size;
  const userRepeatSameAction = numOfActors === 1 && actors.size > 1;
  if (numOfActors === 0) {
    return actionType;
  }
  switch (actionType) {
    case ACTION_LIKE_POST: {
      if (createdByMe) {
        finalActionType = 'liked your post';
      } else {
        finalActionType = `liked ${creator}'s post`;
      }
      break;
    }
    case ACTION_LIKE: {
      if (createdByMe) {
        finalActionType = 'liked your comment';
      } else {
        finalActionType = `liked ${creator}'s comment`;
      }
      break;
    }
    case ACTION_REPLY: {
      if (createdByMe) {
        finalActionType = 'replied to your comment';
      } else if (createdByMe && _.includes(uniqueActors, currentUser)) {
        finalActionType = 'replied to their own comment';
      } else {
        finalActionType = `replied to ${creator}'s comment`;
      }
      // if (trimmedContent) {
      //   finalActionType = finalActionType.concat(` "${trimmedContent}"`);
      // }
      break;
    }
    case ACTION_ADDED_CONTENT: {
      finalActionType = 'made an announcement';
      break;
    }
    case ACTION_NEW_SINGLE_POST: {
      if (userRepeatSameAction || numOfActors > 1) {
        finalActionType = 'made posts';
      } else if (numOfActors === 1) {
        finalActionType = 'made a post';
        // if (trimmedContent) {
        //   finalActionType = finalActionType.concat(` "${trimmedContent}"`);
        // }
      }
      break;
    }
    case ACTION_NEW_POST: {
      if (userRepeatSameAction || numOfActors > 1) {
        finalActionType = 'made posts';
      } else if (numOfActors === 1) {
        finalActionType = 'made a post';
        // if (trimmedContent) {
        //   finalActionType = finalActionType.concat(` "${trimmedContent}"`);
        // }
      }
      break;
    }
    case ACTION_NEW_COMMENT: {
      if (userRepeatSameAction || numOfActors > 1) {
        finalActionType = 'made comments';
      } else if (numOfActors === 1) {
        finalActionType = 'made a comment';
        // if (trimmedContent) {
        //   finalActionType = finalActionType.concat(` "${trimmedContent}"`);
        // }
      }
      break;
    }
    case ACTION_RELEASED: {
      // TODOAPP: WAITNG API TO RETURN ASSESMENT EVALUATION TO GET REPORT NAME
      finalActionType = 'released your assessment report';
      break;
    }
    case ACTION_TAG: {
      finalActionType = 'tagged you in a comment';
      // if (trimmedContent) {
      //   finalActionType = finalActionType.concat(` "${trimmedContent}"`);
      // }
      break;
    }
    case ACTION_BADGE_ISSUED: {
      finalActionType = 'issued you a badge';
      break;
    }
    case ACTION_CERTIFICATE_ISSUED: {
      finalActionType = 'issued you a certificate';
      break;
    }
    case ACTION_CERTIFICATE_REFRESHED: {
      finalActionType = 'updated your certificate';
      break;
    }
    default:
      break;
  }
  return finalActionType;
};

const constructDisplayMessage = (
  actors,
  actionType,
  createdByMe,
  currentUser,
  creator,
  emitterName
) => {
  const actorNames = constructActors(actors);
  const action = constructActionType(
    actors,
    actionType,
    createdByMe,
    currentUser,
    creator
  );
  let displayMessage = `<${actorNames}> ${action}`;
  if (emitterName) {
    displayMessage = displayMessage.concat(` on <${emitterName}>`);
  }
  return displayMessage;
};

export const selectNotificationList = (type) => {
  let selectSubscriptions = null;
  switch (type) {
    case 'read':
      selectSubscriptions = selectReadSubscriptionsById;
      break;
    case 'unread':
      selectSubscriptions = selectUnreadSubscriptionsById;
      break;
    default:
      selectSubscriptions = selectSubscriptionsById;
      break;
  }
  return createSelector(
    [
      selectUsersById,
      currentUserSelector,
      currentUserIdSelector,
      coursesSelector,
      pagesByIdSelector,
      selectCommentsSummaryById,
      selectPostsById,
      selectEventsByChannel,
      selectChannelsById,
      selectSubscriptions,
      certificatesById,
      badgesById,
      cohortsSelector,
      selectInstitutions,
    ],
    (
      users,
      currentUser,
      currentUserId,
      courses,
      pages,
      comments,
      posts,
      eventsByChannel,
      channelsById,
      subscriptions,
      certificates,
      badges,
      cohorts,
      institutions
    ) => {
      let notificationList = Immutable.List();
      const ungroupedActions = [
        ACTION_TAG,
        ACTION_BADGE_ISSUED,
        ACTION_CERTIFICATE_ISSUED,
      ];
      for (const subscription of subscriptions.values()) {
        const subscriptionId = subscription.get('id');
        const channelId = subscription.get('channelId');
        const currentChannel = channelsById.get(channelId);
        const events = eventsByChannel.get(channelId);
        const emitterId = currentChannel.get('emitterId');
        const emitterType = currentChannel.get('emitterType');
        const actionType = currentChannel.get('actionType');
        const lastEventTime = currentChannel.get('lastEventTime');
        const lastEventIndex = currentChannel.get('lastEventIndex');
        let lastEventActorId = currentChannel.get('lastEventActorId');
        let coursePath = currentChannel.get('coursePath');
        let keyPathForCourseName = [coursePath, 'name'];
        let keyPathForCourseTheme = [coursePath, 'themeData', 'theme-color'];
        let courseName = courses.getIn(keyPathForCourseName, '');
        let courseThemeColor = courses.getIn(keyPathForCourseTheme, '');
        let institution = courses.getIn([coursePath, 'institution'], '');
        let institutionName = institutions.getIn([institution, 'name'], '');
        let isOffline = courses.getIn([coursePath, 'isOffline'], '');

        if (
          (emitterType === USER_RESOURCE || emitterType === CERTIFICATE) &&
          _.includes(ungroupedActions, actionType)
        ) {
          // ============================ UNGROUPED NOTIFICATIONS
          for (const event of events.values()) {
            const eventTime = event.get('eventTime');
            const createdId = event.get('createdId');
            const createdType = event.get('createdType');
            let postId = '';
            let emitterName = '';
            let emitterUrl = '';
            let sourcePath = '';
            const createdByMe = false;
            let actors = Immutable.List();
            let createdBy = '';
            let creator = '';
            let highlightTarget = '';
            let scrollToComment = false;
            let cohortPathMixedCase = '';

            // EMITTER TYPE MUST BE USER HERE
            const actor = users.get(lastEventActorId, Immutable.Map());
            if (actor.size > 0) {
              actors = actors.push(actor);
            }
            switch (createdType) {
              case ANNOUNCEMENT: {
                break;
              }
              case COMMENT: {
                /**
                 * ACTION TYPES:
                 * 1. tagged-you-in-a-comment
                 */
                if (createdType === COMMENT) {
                  createdBy = comments.getIn([createdId, 'authorId'], '');
                  creator = users.getIn([createdBy, 'fullName'], '');

                  // get course path from the related comment by using created id
                  coursePath = comments.getIn([createdId, 'coursePath'], '');
                  keyPathForCourseName = [coursePath, 'name'];
                  keyPathForCourseTheme = [
                    coursePath,
                    'themeData',
                    'theme-color',
                  ];
                  courseName = courses.getIn(keyPathForCourseName, '');
                  courseThemeColor = courses.getIn(keyPathForCourseTheme, '');
                  institution = courses.getIn([coursePath, 'institution'], '');
                  institutionName = institutions.getIn(
                    [institution, 'name'],
                    ''
                  );
                  isOffline = courses.getIn([coursePath, 'isOffline'], '');

                  const keyPathForId = [createdId, 'documentId'];
                  const keyPathForType = [createdId, 'documentType'];
                  const documentId = comments.getIn(keyPathForId, '');
                  const documentType = comments.getIn(keyPathForType, '');
                  sourcePath = posts.getIn([documentId, 'source', 'path'], '');
                  if (documentType === PAGE) {
                    emitterUrl =
                      pages.getIn([documentId, 'pageUrl']) ||
                      pages.getIn([documentId, 'url'], '');
                    emitterName = pages.getIn([documentId, 'title'], '');
                  } else if (documentType === COLLECTED_ITEM) {
                    postId = documentId;
                    const keyPathForTitle = [documentId, 'source', 'title'];
                    emitterName = posts.getIn(keyPathForTitle, '');
                    highlightTarget = comments.getIn([createdId, 'id'], '');
                    scrollToComment = true;
                  }
                  break;
                }
                break;
              }
              case CERTIFICATE: {
                // get course path from the related to that certificate
                coursePath = certificates.getIn([createdId, 'coursePath'], '');
                keyPathForCourseName = [coursePath, 'name'];
                keyPathForCourseTheme = [
                  coursePath,
                  'themeData',
                  'theme-color',
                ];
                courseName = courses.getIn(keyPathForCourseName, '');
                courseThemeColor = courses.getIn(keyPathForCourseTheme, '');
                institution = courses.getIn([coursePath, 'institution'], '');
                institutionName = institutions.getIn([institution, 'name'], '');
                isOffline = courses.getIn([coursePath, 'isOffline'], '');

                const cohortPath = certificates.getIn(
                  [createdId, 'cohortPath'],
                  ''
                );
                cohortPathMixedCase = cohorts.getIn(
                  [cohortPath, 'pathMixedCase'],
                  ''
                );
                break;
              }
              case BADGE: {
                // get coursepath from the badge store in order to link to course progress
                const cohortPath = badges.getIn([createdId, 'cohortPath'], '');
                coursePath = cohorts.getIn([cohortPath, 'coursePath'], '');
                keyPathForCourseName = [coursePath, 'name'];
                keyPathForCourseTheme = [
                  coursePath,
                  'themeData',
                  'theme-color',
                ];
                courseName = courses.getIn(keyPathForCourseName, '');
                courseThemeColor = courses.getIn(keyPathForCourseTheme, '');
                institution = courses.getIn([coursePath, 'institution'], '');
                institutionName = institutions.getIn([institution, 'name'], '');
                isOffline = courses.getIn([coursePath, 'isOffline'], '');

                emitterUrl = badges.getIn([createdId, 'pageUrl'], '');
                break;
              }
              default:
                break;
            }
            const avatar = actors.getIn([0, 'avatar@3x']);
            const actorId = actors.getIn([0, 'id']);
            const displayMessage = constructDisplayMessage(
              actors,
              actionType,
              createdByMe,
              currentUser,
              creator,
              emitterName
            );
            const notification = Immutable.Map()
              .set('subscriptionId', subscriptionId)
              .set('channelId', channelId)
              .set('createdId', createdId)
              .set('postId', postId)
              .set('highlightTarget', highlightTarget)
              .set('avatar', avatar)
              .set('actorId', actorId)
              .set('actionName', postId ? 'posted to' : '')
              .set('actionType', actionType)
              .set('displayMessage', displayMessage)
              .set('emitterType', emitterType)
              .set('emitterUrl', emitterUrl)
              .set('eventTime', eventTime)
              .set('courseName', courseName)
              .set('isOffline', isOffline)
              .set('courseThemeColor', courseThemeColor)
              .set('coursePath', coursePath)
              .set('sourcePath', sourcePath)
              .set('institution', institution)
              .set('institutionName', institutionName)
              .set('scrollToComment', scrollToComment)
              .set('cohortPathMixedCase', cohortPathMixedCase);
            notificationList = notificationList.push(notification);
          }
        } else {
          // ============================ GROUPED NOTIFICATIONS
          let actors = Immutable.List();
          let emitterName = '';
          let emitterUrl = '';
          let sourcePath = '';
          let postId = '';
          let createdByMe = false;
          let creator = '';
          let highlightTarget = '';
          let scrollToComment = false;
          let createdId = '';
          let cohortPathMixedCase = '';
          switch (emitterType) {
            case PAGE: {
              /**
               * ACTION TYPES:
               * 1. added-content
               * 2. made-a-comment //
               */
              emitterName = pages.getIn([emitterId, 'title'], '');
              emitterUrl =
                pages.getIn([emitterId, 'pageUrl']) ||
                pages.getIn([emitterId, 'url'], '');
              sourcePath = pages.getIn([emitterId, 'path'], '');
              break;
            }
            case COLLECTED_ITEM: {
              /**
               * ACTION TYPES:
               * 1. made-a-post
               * 2. liked-a-post
               * 3. made-a-comment //
               */
              emitterName = posts.getIn([emitterId, 'source', 'title'], '');
              sourcePath = posts.getIn([emitterId, 'source', 'path'], '');
              postId = emitterId;
              break;
            }
            case COMMENT: {
              /**
               * ACTION TYPES:
               * 1. liked-a-comment
               * 2. replied-to-a-comment
               */
              const keyPathForId = [emitterId, 'documentId'];
              const keyPathForType = [emitterId, 'documentType'];
              const documentId = comments.getIn(keyPathForId, '');
              const documentType = comments.getIn(keyPathForType, '');
              sourcePath = posts.getIn([documentId, 'source', 'path'], '');
              if (documentType === PAGE) {
                emitterUrl =
                  pages.getIn([documentId, 'pageUrl']) ||
                  pages.getIn([documentId, 'url'], '');
                emitterName = pages.getIn([documentId, 'title'], '');
              } else if (documentType === COLLECTED_ITEM) {
                postId = documentId;
                const keyPathForTitle = [documentId, 'source', 'title'];
                emitterName = posts.getIn(keyPathForTitle, '');
                highlightTarget = comments.getIn([emitterId, 'id'], '');
                scrollToComment = true;
              }
              break;
            }
            case CERTIFICATE: {
              // get course path from the related to that certificate
              coursePath = certificates.getIn([emitterId, 'coursePath'], '');
              keyPathForCourseName = [coursePath, 'name'];
              keyPathForCourseTheme = [coursePath, 'themeData', 'theme-color'];
              courseName = courses.getIn(keyPathForCourseName, '');
              courseThemeColor = courses.getIn(keyPathForCourseTheme, '');
              institution = courses.getIn([coursePath, 'institution'], '');
              institutionName = institutions.getIn([institution, 'name'], '');
              isOffline = courses.getIn([coursePath, 'isOffline'], '');

              const cohortPath = certificates.getIn(
                [emitterId, 'cohortPath'],
                ''
              );
              cohortPathMixedCase = cohorts.getIn(
                [cohortPath, 'pathMixedCase'],
                ''
              );
              break;
            }
            default:
              break;
          }
          for (const event of events.values()) {
            let createdBy = '';
            createdId = event.get('createdId');
            const createdType = event.get('createdType');
            const eventIndex = event.get('eventIndex');
            const idAfterUnderscore = /[^_]+$/;
            const postOrCommentId = idAfterUnderscore.exec(createdId)[0];
            if (createdType === LIKE) {
              switch (actionType) {
                /**
                 * ACTION TYPES:
                 * 1. liked-a-post
                 * 2. liked-a-comment
                 */
                case ACTION_LIKE_POST: {
                  createdBy = posts.getIn([postOrCommentId, 'postedBy'], '');
                  creator = users.getIn([createdBy, 'fullName'], '');
                  break;
                }
                case ACTION_LIKE: {
                  createdBy = comments.getIn([postOrCommentId, 'authorId'], '');
                  creator = users.getIn([createdBy, 'fullName'], '');
                  highlightTarget = comments.getIn([postOrCommentId, 'id'], '');
                  scrollToComment = true;
                  break;
                }
                default:
                  break;
              }
              // Gather the actors in this channel from {before}_after
              if (actors.size <= 2) {
                const idBeforeUnderscore = /^[^_]+/;
                const actorId = idBeforeUnderscore.exec(createdId)[0];
                const actor = users.get(actorId, Immutable.Map());
                if (actor.size > 0) {
                  actors = actors.push(actor);
                }
              }
            } else {
              switch (createdType) {
                case COMMENT: {
                  /**
                   * ACTION TYPES:
                   * 1. replied-to-acomment
                   * 2. made-a-comment
                   */
                  const parentComment = comments.getIn(
                    [createdId, 'parentCommentId'],
                    null
                  );
                  createdBy = comments.getIn(
                    [parentComment || createdId, 'authorId'],
                    ''
                  );
                  lastEventActorId = comments.getIn(
                    [createdId, 'authorId'],
                    ''
                  );
                  creator = users.getIn([createdBy, 'fullName'], '');
                  if (lastEventIndex === eventIndex) {
                    highlightTarget = comments.getIn([createdId, 'id'], '');
                    scrollToComment = true;
                  }
                  break;
                }
                case ANNOUNCEMENT: {
                  /**
                   * ACTION TYPES:
                   * 1. added-content
                   */
                  createdBy = pages.getIn([createdId, 'createdBy'], '');
                  creator = users.getIn([createdBy, 'fullName'], '');
                  break;
                }
                case COLLECTED_ITEM: {
                  createdBy = posts.getIn([createdId, 'postedBy'], '');
                  creator = users.getIn([createdBy, 'fullName'], '');
                  break;
                }
                default:
                  break;
              }
              const actor = users.get(lastEventActorId, Immutable.Map());
              if (actor.size > 0) {
                actors = actors.push(actor);
              }
            }
            createdByMe = currentUserId === createdBy;
          }
          postId = posts.has(postId) ? postId : '';
          const avatar = actors.getIn([0, 'avatar@3x']);
          const actorId = actors.getIn([0, 'id']);
          const displayMessage = constructDisplayMessage(
            actors,
            actionType,
            createdByMe,
            currentUser,
            creator,
            emitterName
          );
          const notification = Immutable.Map()
            .set('subscriptionId', subscriptionId)
            .set('channelId', channelId)
            .set('createdId', createdId)
            .set('postId', postId)
            .set('highlightTarget', highlightTarget)
            .set('avatar', avatar)
            .set('actorId', actorId)
            .set('actionName', postId ? 'posted to' : 'released')
            .set('actionType', actionType)
            .set('displayMessage', displayMessage)
            .set('emitterType', emitterType)
            .set('emitterUrl', emitterUrl)
            .set('eventTime', lastEventTime)
            .set('courseName', courseName)
            .set('isOffline', isOffline)
            .set('courseThemeColor', courseThemeColor)
            .set('coursePath', coursePath)
            .set('sourcePath', sourcePath)
            .set('institution', institution)
            .set('institutionName', institutionName)
            .set('scrollToComment', scrollToComment)
            .set('cohortPathMixedCase', cohortPathMixedCase);
          notificationList = notificationList.push(notification);
        }
      }
      notificationList = notificationList.sort((a, b) => {
        return new Date(b.get('eventTime')) - new Date(a.get('eventTime'));
      });
      return notificationList;
    }
  );
};

export const selectUnreadBadge = createSelector(
  notificationsSelector,
  (notifications) => {
    const count = notifications.getIn(['unread', 'badge'], 0);
    if (count === 0) {
      return null;
    }
    return count > 5 ? '5+' : `${count}`;
  }
);

export const selectNotificationFromList = (channelId, createdId) => {
  return createSelector(
    selectNotificationList('all'),
    (notifications) => {
      return notifications
        .filter((notification) => {
          return notification.get('channelId') === channelId;
        })
        .filter((notification) => {
          return notification.get('createdId') === createdId;
        });
    }
  );
};

export const selectUnreadNotifications = selectNotificationList('unread');
export const selectReadNotifications = selectNotificationList('read');
export const selectAllNotifications = selectNotificationList();
